import { createSlice } from '@reduxjs/toolkit'
import { RootState } from '../store/store';

interface AuthState {
    auth: boolean,
    loginType?:string, // parsicuser or lab
    userId?:number,
    userTitle?:string,
    loginTimestamp?:Date,
    taxInfo:any,
    permission:any,
    manager:boolean,
    int_minimumpayment:string,
  }
  
const initialState:AuthState = {
    auth:false,
    loginType:"",
    userId:0,
    userTitle:"",
    loginTimestamp:undefined,
    taxInfo:undefined,
    permission:undefined,
    manager:false,
    int_minimumpayment:'',

}

export const AuthSlice = createSlice({
    name:"Auth",
    initialState,
    reducers:{
        login: (state,action) => {
            
            state.auth = true;
            state.loginType = action.payload.loginType;
            state.userId = action.payload.userId;
            state.userTitle = action.payload.userTitle;
            state.taxInfo = action.payload.taxInfo;
            state.permission = action.payload.permission;
            state.loginTimestamp = undefined; // new Date();
            state.manager=action.payload.manager;
            state.int_minimumpayment=action.payload.int_minimumpayment;
        },
        logout: (state) => {
            state.auth = false;
            state = initialState;
        },
        waitForTaxInfo: (state,action) => {
            
            state.loginType = action.payload.loginType;
            state.userId = action.payload.userId;
            state.userTitle = action.payload.userTitle;
            state.loginTimestamp = undefined; // new Date();
            state.manager=action.payload.manager
            state.int_minimumpayment=action.payload.int_minimumpayment;
        },
        loginAfterEnterTaxInfo: (state,action) => {
            state.auth = true;
        },
        updateTaxInfoSlice: (state,action) => {
            state.taxInfo = action.payload.taxInfo;
        },
       
    }
})

export const {login,logout,waitForTaxInfo,loginAfterEnterTaxInfo,updateTaxInfoSlice} = AuthSlice.actions

export const selectAuth = (state: RootState) => state.auth

export default AuthSlice.reducer;